import useStyle from './index.styles';
import detail from '../../assets/images/detail.png';
import { Button, Drawer, Modal, Progress } from 'antd';
import { useIsMobile } from '../../utils/hooks';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { XmarkSolid } from '../../utils/icons';
import LeaveDetailForm from './LeaveDetailForm';
import dayjs from 'dayjs';

const LeaveDetail = ({
  deceasedName,
  gifExpiredDate,
  reloadMemorial,
  selectedDetail,
}: {
  deceasedName: string;
  gifExpiredDate: string;
  reloadMemorial: () => void;
  selectedDetail: string;
}) => {
  const [showModalForm, setShowModalForm] = useState<boolean>(false);
  const [showModalToWait, setShowModalToWait] = useState<boolean>(false);
  const [resetValues, setResetValues] = useState<boolean>(false);
  const classes = useStyle();
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  useEffect(() => {
    if (resetValues) {
      setShowModalForm(false);
      setResetValues(false);
    }
  }, [resetValues]);

  const onClose = () => {
    setResetValues(true);
    reloadMemorial();
  };

  const daysWithGif = gifExpiredDate ? 30 - dayjs(gifExpiredDate).diff(dayjs(), 'day') : 0;

  const getBodyModalToWait = () => (
    <div className="flex flex-col items-center">
      <img
        src={selectedDetail}
        className="mt-[16px] h-[100px] w-[100px] rounded-[8px] outline outline-2 outline-offset-[-2px] outline-primary"
        alt=""
      />
      <p className="smallParagraphBold mt-[8px] text-text2">{`${daysWithGif}/30`}</p>
      <Progress
        percent={Math.round((100 * daysWithGif) / 30)}
        status="active"
        showInfo={false}
        className="max-w-[128px]"
      />
      <p className="my-[24px] max-w-[300px] text-center">
        {t('leaveDetail.informationOnDaysRemaining', {
          daysRemaining: 30 - daysWithGif,
        })}
      </p>
    </div>
  );

  return (
    <div className="flex justify-center">
      <div className="relative mx-[16px] flex w-[406px] max-w-[406px] md:mx-0 md:ml-[24px] md:max-w-[306px]">
        <img src={selectedDetail || detail} className="h-full w-full rounded-[8px]" alt="" />
        <Button
          className={`absolute bottom-[24px] ml-[32px] w-[calc(100%-64px)] ${
            isMobile ? 'small' : ''
          }`}
          onClick={() => (selectedDetail ? setShowModalToWait(true) : setShowModalForm(true))}
        >
          {t('leaveDetail.shortTitle')}
        </Button>
      </div>
      {isMobile && (
        <>
          <Drawer
            placement="bottom"
            onClose={onClose}
            open={showModalForm}
            closeIcon={<XmarkSolid />}
            rootClassName="drawerMobile drawerWithBigHeight"
            title={t('leaveDetail.title')}
            size="large"
          >
            <LeaveDetailForm
              deceasedName={deceasedName}
              onClose={onClose}
              resetValues={resetValues}
            />
          </Drawer>
          <Drawer
            placement="bottom"
            onClose={() => setShowModalToWait(false)}
            open={showModalToWait}
            closeIcon={<XmarkSolid />}
            rootClassName="drawerMobile"
            title={t('leaveDetail.shortTitle')}
          >
            {getBodyModalToWait()}
          </Drawer>
        </>
      )}
      {!isMobile && (
        <>
          <Modal
            centered
            className={classes.modal}
            closeIcon={<XmarkSolid />}
            footer={null}
            onCancel={onClose}
            open={showModalForm}
            title={null}
            width={1034}
          >
            <LeaveDetailForm
              deceasedName={deceasedName}
              onClose={onClose}
              resetValues={resetValues}
            />
          </Modal>
          <Modal
            centered
            closeIcon={<XmarkSolid />}
            footer={null}
            onCancel={() => setShowModalToWait(false)}
            open={showModalToWait}
            title={t('leaveDetail.shortTitle')}
          >
            {getBodyModalToWait()}
          </Modal>
        </>
      )}
    </div>
  );
};

export default LeaveDetail;
